import { apiClient } from "@/api/softphone_api";
export const setErrorsInList = async ({ commit }, { errorsList }) => {
  commit("setErrors", errorsList);
};
export const toggleErrorsList = async ({ commit }, { toggle }) => {
  commit("toggleShowErrorsModal", toggle);
};

export const saveEnty = async (context, data) => {
  console.log("DATA POST: ", data);
  const url = `/api/crm/register_page/`;
  const res = await apiClient.post(url, data);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
};
export const getEnty = async ({ commit }, params) => {
  const url = `/api/webrtc/${params.url}`;
  const res = await apiClient.get(url);
  console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data.results });
};
export const getEntyMeet = async ({ commit }, params) => {
  const url = `/api/webrtc/${params.url}`;
  const res = await apiClient.get(url);
  console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data });
};
export const downloadEntyExcel = async (context, params) => {
  const url = `/api/webrtc/${params.url}`;
  const res = await apiClient.get(url, { responseType: "blob" });
  return res;
};
export const uploadFile = async ({ commit }, params) => {
  var data = new FormData();
  data.append("audio_file", params.file);
  data.append("format", params.format);
  data.append("size", params.size);

  console.log("NUEVO ARCHIVO : ", params.file);
  const url = `/api/webrtc/convert_audio/`;
  const res = await apiClient.post(url, data);
  if (res.data && res.data.error) {
    throw new Error(res.data.error);
  }
  commit(params.mutation1, { key: params.enty, value: res.data });
  console.log(res, params);
};
export const getParamsEnty = async ({ commit }, params) => {
  const url = `/api/webrtc/${params.url}`;
  console.log("url", url);
  const res = await apiClient.post(url, params.data);
  commit(params.mutation1, { key: params.enty, value: res.data.records });
  commit(params.mutation1, { key: "grabacionesTotal", value: res.data.total });
  commit(params.mutation1, { key: "grabacionesIndicators", value: res.data.indicators });
};
export const loadDataZohoConfigCrm = async ({ commit }) => {
  const url = "api/admin/zoho-configuration-crm/";
  const res = await apiClient.get(url);
  commit("setZohoConfigData", res.data);
};

export const loadDataZohoDeskConfigCrm = async ({ commit }) => {
  const url = "api/admin/zoho-configuration-desk/";
  const res = await apiClient.get(url);
  commit("setZohoDeskConfigData", res.data);
};

export const loadDataZohoUser = async ({ commit }, idUser) => {
  const url = "api/admin/zoho-configuration-user/";
  const data = {
    params: {
      user_id: idUser,
    },
  };
  const res = await apiClient.get(url, data);
  console.log({ res });
  commit("setZohoUserData", res.data);
};
export const getDefault = async ({ commit }, params) => {
  const url = `/api/${params.url}`;
  const res = await apiClient.get(url);
  console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data });
};
export const postDefault = async ({ commit }, params) => {
  console.log("DATA POST: ", params.data);
  const url = `/api/${params.url}`;
  const res = await apiClient.post(url, params.data);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data });
};
export const patchDefault = async ({ commit }, params) => {
  console.log("DATA PUT: ", params.data);
  const url = `/api/${params.url}/`;
  const res = await apiClient.patch(url, params.data);
  console.log(`RESPONSE PUT ENTY TO ${url}`, res);
  commit(params.mutation1, {
    key: params.enty,
    results: params.results,
    keySearch: params.keySearch,
    value: res.data,
  });
  return res;
};
export const deleteDefault = async ({ commit }, params) => {
  console.log("DATA DELETE: ", params);
  const url = `/api/${params.url}`;
  const res = await apiClient.delete(url);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(params.mutation1, {
    key: params.enty,
    keySearch: params.keySearch,
    value: res.data,
  });
};
